import ExternalAuthService from '@/apiClient/ExternalAuthService'
import Vue from 'vue'

// Estado reactivo compartido
const state = Vue.observable({
  tokenValid: false,
  authenticated: false,
  performanceSourceUrl: null,
  currentOrigin: null,
  tokenValuePerformance: null
})

class IframeMessageHandler {
  constructor() {
    this.authService = new ExternalAuthService()
    this.handlePostMessage = this.handlePostMessage.bind(this)
    this.pendingMessages = []
    this.isAuthenticated = false
    this._state = state
  }

  /**
   * Envía una respuesta de error al padre
   * @param {Error} error - Error capturado 
   * @param {string} context - Contexto donde ocurrió el error
   */
  sendErrorResponse(error, context = 'unknown') {
    try {
      console.error(`IframeMessageHandler Error (${context}):`, error)
      this.setTokenValid(false)
      const pathHasLogin = window.location.pathname.includes('/login')

      const targetOrigin = this._state.currentOrigin || this._state.performanceSourceUrl;
      window.parent.postMessage({
        type: 'MANDU_AUTH_STATUS',
        valid: false,
        error: (error && error.message) ? error.message : 'Error desconocido',
        context,
        source: 'sichern-iframe',
        pathHasLogin
      }, targetOrigin)
    } catch (sendError) {
      console.error('Error enviando respuesta de error:', sendError)
    }
  }

  /**
   * Envía notificación de error en auto-login con performanceToken
   * @param {Error} error - Error del login
   */
  sendAutoLoginError(error) {
    try {
      const errorMessage = (error && error.response && error.response.data && error.response.data.message) 
        || (error && error.message) 
        || 'Token de performance inválido'
      const errorCode = (error && error.response && error.response.data && error.response.data.code) 
        || 'INVALID_PERFORMANCE_TOKEN'
      const targetOrigin = this._state.currentOrigin || this._state.performanceSourceUrl;
      
      console.error('Auto-login failed:', errorMessage, errorCode)
      this.setTokenValid(false)
      
      window.parent.postMessage({
        type: 'MANDU_AUTH_STATUS',
        valid: false,
        error: errorMessage,
        code: errorCode,
        context: 'auto-login-failed',
        source: 'sichern-iframe'
      }, targetOrigin)
    } catch (sendError) {
      console.error('Error enviando auto-login error:', sendError)
    }
  }

  /**
   * Inicializa el listener de mensajes
   */
  init() {
    try {
      this.destroy();
      window.addEventListener('message', this.handlePostMessage)
      this.detectAuthenticationOnReload()

    } catch (error) {
      this.sendErrorResponse(error, 'init')
    }
  }

  /**
   * Elimina el listener de mensajes
   */
  destroy() {
    try {
      window.removeEventListener('message', this.handlePostMessage)
      if (this.beforeUnloadListener) {
        window.removeEventListener('beforeunload', this.beforeUnloadListener)
        this.beforeUnloadListener = null
      }
      
      // Limpiar estado completo
      this.pendingMessages = []
      this.isAuthenticated = false
      
      // Reset estado reactivo
      this.setTokenValid(false)
      this.setPerformanceSourceUrl(null)
      this.setCurrentOrigin(null)
      
    } catch (error) {
      console.error('Error en destroy:', error)
    }
  }

  /**
   * Establece el estado de autenticación
   * @param {boolean} status - Estado de autenticación
   */
  setAuthenticationStatus(status) {
    try {
      this.isAuthenticated = status

      // Procesar mensajes pendientes si estamos autenticados
      if (status && this.pendingMessages.length > 0) {
        this.processPendingMessages()
      }
    } catch (error) {
      this.sendErrorResponse(error, 'setAuthenticationStatus')
    }
  }

  /**
   * Procesa los mensajes pendientes
   */
  processPendingMessages() {
    try {
      // Crear copia para iterar y vaciar la cola original
      const messagesToProcess = [...this.pendingMessages]
      this.pendingMessages = []

      messagesToProcess.forEach(message => {
        // Para mensajes pendientes, usar la URL almacenada si está disponible
        this.processAuthMessage(message)
          .catch(error => this.sendErrorResponse(error, 'processPendingMessages'))
      })
    } catch (error) {
      this.sendErrorResponse(error, 'processPendingMessages')
    }
  }

  /**
   * Detecta si el iframe se recarga y envía un mensaje al padre
   */
  detectAuthenticationOnReload() {
    this.beforeUnloadListener = () => {
      try {
        // Enviar notificación de que el iframe se va a recargar
        window.parent.postMessage({
          type: 'IFRAME_BEFORE_RELOAD',
          source: 'sichern-iframe'
        }, this._state.performanceSourceUrl || this._state.currentOrigin )
      } catch (error) {
        this.sendErrorResponse(error, 'detectAuthenticationOnReload')
      }
    };
    window.addEventListener('beforeunload', this.beforeUnloadListener);
  }


  /**
   * Procesa un mensaje de autenticación
   * @param {Object} messageData - Datos del mensaje con token
   */
  async processAuthMessage(messageData) {
    try {
      const { type, payload } = messageData

      if (type === "MANDU_AUTH" && payload && payload.token) {
        const token = payload.token
        const pathHasLogin = window.location.pathname.includes('/login')

        // Obtener el token de autenticación desde localStorage
        const authToken = localStorage.getItem('jwt') 

        if (!authToken) {
          /// redireccionar al login
          window.location.href = '/login'

        }

        // Envía el token externo como parámetro, el método ya maneja la autorización Bearer automáticamente
      //  const response = await this.authService.validateExternalToken(token)


          this.setTokenValid(true)
                // Usar el origin almacenado como performanceSourceUrl
      const targetOrigin = this._state.currentOrigin;
      console.log('🌐 Usando targetOrigin para respuesta:', targetOrigin);
      if (this._state.currentOrigin) {
        this.setPerformanceSourceUrl(this._state.currentOrigin)
      }

          window.scrollTo(0, 0);
          window.parent.postMessage({
            type: 'MANDU_AUTH_STATUS',
            valid: true,
            pathHasLogin,
            source: 'sichern-iframe'
          }, targetOrigin)
      }
    } catch (error) {
      this.sendErrorResponse(error, 'processAuthMessage')
    }
  }

  /**
   * Maneja los mensajes recibidos vía postMessage
   */
  async handlePostMessage(event) {
    try {
      // Si no es un objeto, ignorar silenciosamente
      if (typeof event.data !== 'object') return

      const { type, payload, source } = event.data



        // Manejar acción clearLocalStorage desde Performance app
        if (type === 'clearLocalStorage' && source === 'performance-app-frontend') {
            try {
                localStorage.clear()
                window.parent.postMessage({
                    type: 'LOCALSTORAGE_CLEARED',
                    success: true,
                    source: 'sichern-iframe'
                }, event.origin || this._state.performanceSourceUrl);
                                
                // Redireccionar al login después de enviar la confirmación
                setTimeout(() => {
                    window.location.href = '/login';
                }, 100);
                
            } catch (error) {
                console.error('❌ Vue.js - Error al limpiar localStorage:', error);
                this.sendErrorResponse(error, 'clearLocalStorage')
            }
        }
      // Si es mensaje de autenticación
      if (type === "MANDU_AUTH" && payload && payload.token) {

        //se obtuvo el token 
        this.setTokenPerformanceValue(payload.token)

      // Almacenar el origen actual si está disponible
      if (event.origin && event.origin !== 'null') {
        this.setCurrentOrigin(event.origin)
      }
        // Si no estamos autenticados, almacenar para procesar después
        if (!this.isAuthenticated) {
          //mandar un mensaje al padre para que espere
          window.parent.postMessage({
            type: 'MANDU_AUTH_PENDING',
            message: 'Esperando autenticación antes de procesar el mensaje',
            source: 'sichern-iframe'
          }, this._state.currentOrigin)
          this.pendingMessages.push(event.data)
          return
        }

        // Si ya estamos autenticados, procesar ahora
        await this.processAuthMessage(event.data)
      }

    } catch (error) {
      this.sendErrorResponse(error, 'handlePostMessage')
    }
  }
  hasPendingMessages() {
    return this.pendingMessages.length > 0;
  }
  isTokenValid() {
    return this._state.tokenValid
  }
  performanceSourceUrlData() {
    return this._state.performanceSourceUrl
  }
  setTokenValid(value) {
    this._state.tokenValid = value
    // Agregar o quitar clase iframe-mode del body según el estado del token
    if (value) {
      document.body.classList.add('iframe-mode')
    } else {
      document.body.classList.remove('iframe-mode')
    }
  }
  setPerformanceSourceUrl(value) {
    this._state.performanceSourceUrl = value
  }
  setCurrentOrigin(value) {
    this._state.currentOrigin = value
  }
  getTokenPerformanceValue() {
    return this._state.tokenValuePerformance;
  }
  setTokenPerformanceValue(token) {
    this._state.tokenValuePerformance = token;
  }

  /**
   * Verifica si la ventana está en un iframe
   * @returns {boolean}
   */
  isInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  /**
   * Maneja la expiración de sesión
   */
  async handleSessionExpired() {
    try {
      const performanceToken = this.getTokenPerformanceValue()

      if (!performanceToken) {
        console.error('❌ No hay Performance token para reautenticar')
        this.notifySessionExpired()
        return
      }

      console.log('🔐 Intentando reautenticar con Performance token...')

      // Intentar validar el token de Performance (esto debería hacer login automático)
      const response = await this.authService.validateExternalToken(performanceToken)

      if (response && response.data && response.data.jwt) {
        console.log('✅ Reautenticación exitosa')
        
        // Actualizar JWT en localStorage
        localStorage.setItem('jwt', response.data.jwt)

        // Notificar al padre
        window.parent.postMessage({
          type: 'MANDU_SESSION_RENEWED',
          success: true,
          source: 'sichern-iframe'
        }, this._state.currentOrigin || this._state.performanceSourceUrl)

      } else {
        throw new Error('Respuesta de autenticación inválida')
      }

    } catch (error) {
      console.error('❌ Error en reautenticación:', error)
      this.notifySessionExpired()
    }
  }

  /**
   * Notifica al padre que la sesión expiró
   */
  notifySessionExpired() {
    window.parent.postMessage({
      type: 'MANDU_SESSION_EXPIRED',
      message: 'Sesión expirada, no se pudo renovar',
      source: 'sichern-iframe'
    }, this._state.currentOrigin || this._state.performanceSourceUrl || '*')

    this.stopKeepAlive()
  }
}

// Singleton para el manejo de mensajes
const messageHandler = new IframeMessageHandler()

// Plugin para Vue
export default {
  install(Vue) {
    // Evitar doble instalación
    if (Vue.prototype.$iframeMessages) {
      console.warn('IframeMessageHandler ya instalado, destruyendo instancia anterior')
      Vue.prototype.$iframeMessages.destroy()
    }

    try {
      // Limpiar estado previo completamente
      messageHandler.destroy()
      
      // Reset del estado reactivo
      Object.assign(state, {
        tokenValid: false,
        authenticated: false,
        performanceSourceUrl: null,
        currentOrigin: null,
        tokenValuePerformance: null
      })

      // Inicializar fresh
      messageHandler.init()

      Vue.prototype.$iframeMessages = {
        init: () => messageHandler.init(),
        destroy: () => messageHandler.destroy(),
        setAuthenticated: (status) => messageHandler.setAuthenticationStatus(status),
        hasPendingMessages: () => messageHandler.hasPendingMessages(),
        isTokenValid: () => messageHandler.isTokenValid(),
        performanceSourceUrlData: () => messageHandler.performanceSourceUrlData(),
        getTokenPerformanceValue: () => messageHandler.getTokenPerformanceValue(),
        sendAutoLoginError: (error) => messageHandler.sendAutoLoginError(error),
        setTokenValid: (value) => messageHandler.setTokenValid(value),
        isInIframe: () => messageHandler.isInIframe()
      }

    } catch (error) {
      console.error('Error instalando plugin IframeMessageHandler:', error)
    }
  }
}